import { _decorator, Enum, Node, CCInteger, CurveRange } from 'cc';
import { DEV } from 'cc/env';
import BaseAction from './BaseAction';

const { ccclass, property } = _decorator;

// 節點行為
export enum NodeActionType {
    Active,
    Inactive,
    Show,
    Hide,
    FadeIn,
    FadeOut,
    TweenStop,
    TweenJumpToEnd,
}

@ccclass('RandomMultiThemeConfig')
export class RandomMultiThemeConfig {
    @property(CCInteger)
    public readonly theme: number = 0;
    @property(CCInteger)
    public readonly randomWeight: number = 1;
}

@ccclass('NodeAction')
export default class NodeAction extends BaseAction {
    @property({ type: Node, displayName: DEV && '節點目標', tooltip: DEV && '要操作的節點目標' })
    public readonly nodeTarget: Node = null;
    @property({
        type: Enum(NodeActionType),
        displayName: DEV && '操作類型',
        tooltip:
            DEV &&
            '要進行什麼行為\r\nActive: 顯示\r\nInActive: 關閉\r\nShow: 將透明度設為255\r\nHide: 將透明度設為0\r\nFadeIn: 透明度漸入表演\r\nFadeOut: 透明度淡出表演\r\nTweenStop: 停止Tween動畫\r\nTweenJumpToEnd: 跳至Tween動畫結束',
    })
    public readonly type: NodeActionType = NodeActionType.Active;
    @property({
        type: CCInteger,
        displayName: DEV && '漸動時長',
        tooltip: DEV && 'FadeIn / FadeOut 表演時長 (單位: 毫秒)',
        visible() {
            return this.type === NodeActionType.FadeIn || this.type === NodeActionType.FadeOut;
        },
    })
    public readonly fadeDuration: number = 0;
    @property({
        displayName: DEV && '漸動後調整Active',
        tooltip: DEV && '啟用時 FadeIn前 或 FadeOut後 \r\n會調整節點 Active 狀態',
        visible() {
            return this.type === NodeActionType.FadeIn || this.type === NodeActionType.FadeOut;
        },
    })
    public readonly fadeAdjustActive: boolean = false;
    @property({
        displayName: DEV && '使用自定義曲線',
        tooltip: DEV && 'FadeIn與FadeOut表演指定漸動曲線,\r\n未啟用時預設為線姓表演',
        visible() {
            return this.type === NodeActionType.FadeIn || this.type === NodeActionType.FadeOut;
        },
    })
    public readonly fadeUseCustomCurve: boolean = false;
    @property({
        type: CurveRange,
        displayName: DEV && '漸動曲線',
        tooltip: DEV && 'FadeIn與FadeOut使用的漸動曲線',
        visible() {
            return this.fadeUseCustomCurve;
        },
    })
    public readonly fadeCustomCurve: CurveRange = new CurveRange();
    @property({
        displayName: DEV && '調整ZIndex',
        tooltip: DEV && '是否調整ZIndex數值',
    })
    public readonly updateZIndex: boolean = false;
    @property({
        displayName: DEV && 'zIndex',
        tooltip: DEV && '新的zIndex數值',
        type: CCInteger,
        visible() {
            return this.updateZIndex;
        },
    })
    public readonly zIndex: number = 0;
    @property({
        displayName: DEV && '調整父節點',
        tooltip: DEV && '是否調整父節點',
    })
    public readonly updateParentNode: boolean = false;
    @property({
        displayName: DEV && '父節點',
        tooltip: DEV && '要調整成哪一個父節點',
        type: Node,
        visible() {
            return this.updateParentNode;
        },
    })
    public readonly parentNode: Node = null;
    @property({
        displayName: DEV && '調整MultiTheme',
        tooltip: DEV && '是否調整MultiTheme',
    })
    public readonly updateMultiTheme: boolean = false;
    @property({
        displayName: DEV && 'Theme',
        tooltip: DEV && '要調整成哪一個MultiTheme',
        type: CCInteger,
        visible() {
            return this.updateMultiTheme && !this.updateRandomMultiTheme;
        },
    })
    public readonly theme: number = 0;
    @property({
        displayName: DEV && '隨機調整MultiTheme',
        tooltip: DEV && '隨機調整MultiTheme',
        visible() {
            return this.updateMultiTheme;
        },
    })
    public readonly updateRandomMultiTheme: boolean = false;
    @property({
        displayName: DEV && '隨機調整MultiTheme列表',
        tooltip: DEV && '隨機調整MultiTheme',
        type: [RandomMultiThemeConfig],
        visible() {
            return this.updateMultiTheme && this.updateRandomMultiTheme;
        },
    })
    public readonly randomMultiThemeList: RandomMultiThemeConfig[] = [];
}
